import type { FC } from 'react';

import TextArea from '../../../textarea/textarea';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = ['placeholder', 'autoSize', 'onKeyDown'] as const;

const Field = formField(TextArea, {
  defaultValue: '',
  transformProps: (props) => pickProps(props, componentProps),
});

export type TextAreaFieldWrapperProps = FieldWrapperProps<typeof Field>;

const TextAreaFieldWrapper: FC<TextAreaFieldWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default TextAreaFieldWrapper;
